import { FC } from 'react';

import Paragraph from '@/components/text/Paragraph.tsx';

import { dayjs } from '@/utils/dayjsSetup.ts';
import { cn } from '@/utils/styleUtils.ts';

interface Props {
    creator?: string;
    createdAt?: string;
    className?: string;
}

const TaskCreator: FC<Props> = ({ creator, createdAt, className }) => (
    <div className={cn('flex gap-2 text-sm', className)}>
        {createdAt && <Paragraph>Erstellt am: {dayjs(createdAt).format('DD.MM.YYYY')}</Paragraph>}
        {creator && <Paragraph>Von: {creator}</Paragraph>}
    </div>
);

export default TaskCreator;
